import { InvoiceReportsSearchFormData } from '@/features/invoice_reports/components/Search/hooks/useSearchForm';
import { PropsControl } from '@/features/invoice_reports/components/Search/type';
import {
  FormInput,
  FormInputProps,
} from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';

type Props = PropsControl & FormInputProps<InvoiceReportsSearchFormData>;

export const FromInputSearch: FC<Props> = memo(({ control, name, ...rest }) => {
  return (
    <FormInput<InvoiceReportsSearchFormData>
      name={name}
      control={control}
      {...rest}
    />
  );
});
FromInputSearch.displayName = 'FromInputSearch';
